<template>
  <mdb-container>
    <mdb-card>
      <mdb-card-body class="text-left">
        <editor v-if="!executing" :group="currentGroup"
                @wizardDone="doSave"
                :field="details.text" @input="details.text = $event" label="Event Details"/>
      </mdb-card-body>
      <mdb-card-footer>
        <mdb-btn v-if="details" @click="doSave">
          <mdb-icon icon="save"/>
          Save
        </mdb-btn>
        <mdb-btn @click="doCancel">
          <mdb-icon icon="window-close"/>
          Cancel
        </mdb-btn>
      </mdb-card-footer>
    </mdb-card>

    <div v-if="showSeriesModal">
      <series-modal @closeModal="showSeriesModal=false" @seriesChoice="setSeriesChoice"/>
    </div>

  </mdb-container>

</template>

<script>
import api from '../../services/groupsPlaceApi.js'
import Editor from "../group/Editor";
import SeriesModal from "./SeriesModal";
import {mdbBtn, mdbCard, mdbCardBody, mdbCardFooter, mdbCardHeader, mdbContainer, mdbIcon} from 'mdbvue';

export default {
  name: 'Event-Details-Editor',
  components: {
    mdbBtn,
    mdbIcon,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardFooter,
    mdbContainer,
    SeriesModal,
    Editor
  },
  props: {
    details: {
      type: Object,
      default: null
    }
  },
  computed: {
    userDetails() {
      return this.$store.state.userDetails
    },
    currentGroup() {
      return this.$store.state.currentGroup
    },
    executing() {
      return this.$store.state.executing
    }
  },
  data() {
    return {
      showSeriesModal: false,
      seriesChoice: null
    }
  },
  methods: {
    setSeriesChoice(choice) {
      this.seriesChoice = choice
      this.doSave()
    },
    doSave() {
      if (this.details.repeats && !this.seriesChoice && this.details.status != "Draft") {
        this.showSeriesModal = true
        return
      }
      this.$store.dispatch("setExecuting", true);
      let p = {text: this.details.text}
      if (this.details.repeats && this.seriesChoice) p.series = this.seriesChoice
      api.post("/event/details/" + this.details.eventId, p).then(
        (results) => {
          this.$emit("saveDetails", results.data)
        },
        (error) => {
          if (error.response && error.response.status == 403) {
            if (error.response.data) {
              this.$notify.error({message: "Security Error: " + error.response.data, timeOut: 10000})
            }
            else this.$notify.error({message: "Access Denied.", timeOut: 10000})
          }
          else this.$notify.error({message: error.response.data, timeOut: 10000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
        this.showSeriesModal = false
        this.seriesChoice = null
      })
    },
    doCancel() {
      this.$emit("cancelDetails")
    }
  }
}
;
</script>
<style lang="scss">
@import '~vue-datetime/dist/vue-datetime.min';
</style>
